export class Communication {
    notificationTemplateId?: string;
    title: string;
    message: string;
    notificationTrigger?: number;
    startDate: string;
    endDate: string;
    notificationTypes: Array<number>;
    notificationCheckType: number;
    placeHolder?: string;
    isSystemNotification?: boolean; // * custom property
    systemStartDate?: string; // * custom property
    systemEndDate?: string; // * custom property
    messageForDisplay?: string;
}

export class SystemMaintenanceModel {
    notificationCheckType: number;
    notificationTypes: Array<number>;
    notificationTypeIndex: number;
    placeholder: string;
    startDate: string;
    endDate: string;
}
